<template>
	<div class="label-value-wrapper" :size="size">
		<div class="label">
			{{ label }}
		</div>
		<div class="value">
			{{ value }}
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";
/**
 * Generic component used to display key value data
 */
export default defineComponent({
	name: "LabelValue",
	props: {
		/**
		 * 'small' | 'medium' | 'large' | 'x-large'
		 */
		size: {
			type: String,
			default: "medium",
			validator(value) {
				return ["small", "medium", "large", "x-large"].includes(value);
			}
		},
		/**
		 * Left side string
		 */
		label: {
			type: String,
			default: ""
		},
		/**
		 * Right side string
		 */
		value: {
			type: String,
			default: ""
		}
	}
});
</script>
<style lang="scss">
@use "sass:map";
$label-color: var(--dashboard-font-dark);
$value-color: var(--dashboard-font-dark);
$label-value-sizes: "small", "medium", "large", "x-large";
$font-sizes: (
	"small": 10px,
	"medium": 14px,
	"large": 18px,
	"x-large": 22px
);

.label-value-wrapper {
	display: flex;
	flex-direction: row;
	@each $size in $label-value-sizes {
		&[size="#{$size}"] {
			font-size: map-get($font-sizes, $size);
			line-height: map-get($font-sizes, $size);
		}
	}
	> .label {
		color: $label-color;
		font-weight: 200;
	}
	> .value {
		font-weight: 500;
		color: $value-color;
		margin-left: 8px;
	}
}
</style>
